import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { AppTitleComponent } from '../core/components/app-title/app-title.component';
import { NavigateBackDirective } from '../toExtract/back-navigation/navigate-back.directive';

@Component({
  selector: 'pd-tos',
  templateUrl: './tos.component.html',
  styleUrls: ['./tos.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    MatButtonModule,
    NavigateBackDirective,
    MatIconModule,
    AppTitleComponent,
    RouterLink,
  ],
})
export class TosComponent {}
